<template>
	<!-- //cards -->
	<div class="card w-full sm:w-1/2 lg:w-1/4 px-3 mb-3" data-aos="fade-up">
		<div
			class="rounded shadow bg-gray-800 transition transition-transform duration-100 ease-in-out transform hover:-translate-y-3"
		>
			<div>
				<img
					:src="song.song_art_image_url"
					class="h-full w-full object-cover rounded-t"
					alt=""
				/>
			</div>
			<div class="px-4 py-4">
				<h1 class="font-bold text-2xl uppercase text-gray-300">
					{{ song.title.trim() }}
				</h1>
				<router-link
					class="bg-indigo-500 hover:bg-indigo-400 mt-5 text-white rounded text-center block py-1 px-2"
					:to="'/song/' + song.id"
					>Check it out</router-link
				>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'ListAlbum',
	props: {
		song: Object
	}
};
</script>
